import { Dispatch, ReactElement, SetStateAction, createContext, useState } from 'react';
import { MinimalTarget, PlutoPerson } from '@/generated/model';
import { ReportTabValue } from '@/types';

export type ReportContextType = {
  tab: ReportTabValue;
  setTab: Dispatch<SetStateAction<ReportTabValue>>;
  selectedTargets: MinimalTarget[] | undefined;
  setSelectedTargets: Dispatch<SetStateAction<MinimalTarget[] | undefined>>;
  selectedDates: { from: Date; to: Date } | undefined;
  setSelectedDates: Dispatch<SetStateAction<{ from: Date; to: Date } | undefined>>;
  searchText: string | undefined;
  setSearchText: Dispatch<SetStateAction<string | undefined>>;
  selectedTemplateIds: number[];
  setSelectedTemplateIds: Dispatch<SetStateAction<number[]>>;
  addressee: string | undefined;
  setAddressee: Dispatch<SetStateAction<string | undefined>>;
  selectedDrivers: PlutoPerson[] | undefined;
  setSelectedDrivers: Dispatch<SetStateAction<PlutoPerson[] | undefined>>;
  maxTargetNumber: number;
  setMaxTargetNumber: Dispatch<SetStateAction<number>>;
};

export const ctxReport = createContext<ReportContextType | undefined>(undefined);

export function ReportContext({ children }: { children: ReactElement }) {
  const [tab, setTab] = useState<ReportTabValue>(ReportTabValue.dateSelect);
  const [selectedTargets, setSelectedTargets] = useState<MinimalTarget[] | undefined>(undefined);
  const [selectedDates, setSelectedDates] = useState<{ from: Date; to: Date } | undefined>(undefined);
  const [searchText, setSearchText] = useState<string | undefined>(undefined);
  const [selectedTemplateIds, setSelectedTemplateIds] = useState<number[]>([]);
  const [addressee, setAddressee] = useState<string | undefined>(undefined);
  const [selectedDrivers, setSelectedDrivers] = useState<PlutoPerson[] | undefined>(undefined);
  const [maxTargetNumber, setMaxTargetNumber] = useState<number>(0);

  return (
    <ctxReport.Provider
      value={{
        tab,
        setTab,
        selectedTargets,
        setSelectedTargets,
        selectedDates,
        setSelectedDates,
        searchText,
        setSearchText,
        selectedTemplateIds,
        setSelectedTemplateIds,
        addressee,
        setAddressee,
        selectedDrivers,
        setSelectedDrivers,
        maxTargetNumber,
        setMaxTargetNumber,
      }}
    >
      {children}
    </ctxReport.Provider>
  );
}
